import React from 'react';

import '../styles/SideBarRight.css';
import '../styles/SideBarToggle.css';
import '../styles/phcolours.css';

import CollapseIconHover from '../../images/IconRightArrowBlue@3x.png';
import CollapseIcon from '../../images/IconRightArrowGrey@3x.png';

export default function UsageSideBarRight({
  isExpanded = true,
  onRequestClose = () => { },
  selectedPin = null,
  clearSelection = () => { },
}) {

  const [isSideBarCollapseButtonHovering, setIsSideBarCollapseButtonHovering] = React.useState(false);

  return (
    <div
      className="sidebar sidebar-right"
      style={{
        width: '100%',
        flex: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderLeft: isExpanded ? '0.75px solid #596A99' : 'none',
        transition: 'flex-basis 0.3s ease, opacity 0.3s ease',
        opacity: isExpanded ? 1 : 0,
      }}
    >

      <button
        className="sidebar-toggle-button sidebar-right-toggle-button-expanded"
        onClick={onRequestClose}
        onMouseEnter={() => setIsSideBarCollapseButtonHovering(true)}
        onMouseLeave={() => setIsSideBarCollapseButtonHovering(false)}
      >
        <img
          src={isSideBarCollapseButtonHovering ? CollapseIconHover : CollapseIcon}
          alt="Hide Sidebar"
        />
      </button>

      <div className="sidebar-inner">
        <div className="sidebar-heading-row" style={{ marginTop: 20 }}>
          <span className="sidebar-heading-label active">Pin Details</span>
        </div>

        {!selectedPin && (
          <div style={{ marginTop: 16, color: 'var(--phgrey)', fontSize: 13 }}>
            Click a pin to see details.
          </div>
        )}

        {selectedPin && (
          <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <div className="sidebarRight-landinfo-row">
              <span style={{ fontWeight: 600 }}>Name</span>
              <span>{selectedPin.nameOfUser || '—'}</span>
            </div>
            <div className="sidebarRight-landinfo-row">
              <span style={{ fontWeight: 600 }}>Plan</span>
              <span>{selectedPin.planName || '—'}</span>
            </div>
            <div className="sidebarRight-landinfo-row">
              <span style={{ fontWeight: 600 }}>Style</span>
              <span>{selectedPin.style || '—'}</span>
            </div>
            <div className="sidebarRight-landinfo-row">
              <span style={{ fontWeight: 600 }}>Client Type</span>
              <span>{selectedPin.clientType || '—'}</span>
            </div>
            <div className="sidebarRight-landinfo-row">
              <span style={{ fontWeight: 600 }}>Coordinates</span>
              <span>
                {selectedPin.coordinates
                  ? `${selectedPin.coordinates.lat?.toFixed(6)}, ${selectedPin.coordinates.lng?.toFixed(6)}`
                  : '—'}
              </span>
            </div>
            <div className="sidebarRight-landinfo-row">
              <span style={{ fontWeight: 600 }}>Created</span>
              <span>{selectedPin.createdAt ? new Date(selectedPin.createdAt).toLocaleString() : '—'}</span>
            </div>

            <div
              className="sidebarRight-landinfo-row"
              onClick={clearSelection}
              style={{
                marginTop: 14,
                justifyContent: 'center',
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor: 'var(--phwashedorangebackground)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--phorangefont)';
                e.currentTarget.querySelector('span').style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--phwashedorangebackground)';
                e.currentTarget.querySelector('span').style.color = 'var(--phorangefont)';
              }}
            >
              <span style={{ color: 'var(--phorangefont)', fontWeight: 500 }}>
                Clear selection
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
